import { render, staticRenderFns } from "./SubscribeWelcome.vue?vue&type=template&id=1a66a347&"
import script from "./SubscribeWelcome.vue?vue&type=script&lang=js&"
export * from "./SubscribeWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports